import React from 'react';

import './SavedArticleList.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';
import BackButton from '../BackButton/BackButton.jsx';

const { Heart } = icons;

export default function SavedArticleList(props) {
  const { list, removeBookmark } = props;

  return (
    <section id="savedArticleList">
      <BackButton />

      <ul>
        {list.map(({ id, content }) =>
          content ? (
            <li className="savedArticleList_item" key={id}>
              <div>
                <p>
                  {link(
                    <span className="savedArticleList_item_title">
                      {content.title}
                    </span>,
                    content.uri
                  )}
                </p>

                <img src={content.author.imageUrl} alt="author-image" />

                <span className="savedArticleList_author">
                  {content.author.displayName}
                </span>
              </div>

              <span onClick={() => removeBookmark({ variables: { id } })}>
                <Heart />
              </span>
            </li>
          ) : null
        )}
      </ul>

      <button className="savedArticleList-button">
        Alle artikelen verwijderen
      </button>
    </section>
  );
}
